<div class="dashboard-locator" *ngIf="model">
  <!-- Navigation Cards Section with Daily Stats -->
  <div class="dashboard-locator__nav-section fade-in-up">
    <!-- Navigation Cards -->
    <a *authGuardDirective="'contacts'" [routerLink]="['/contacts']" class="nav-card nav-card--contacts">
      <div class="icon">
        <i class="fa fa-users"></i>
      </div>
      <div class="nav-card-content">
        <h3 class="title">כרטסת אנשי קשר</h3>
        <p class="description">ניהול מתקדם של מסד הנתונים</p>
      </div>
    </a>

    <a *authGuardDirective="'ivrDonationDetails'" [routerLink]="['/ivrDonationDetails']"
      class="nav-card nav-card--donations">
      <div class="icon">
        <i class="fa fa-phone"></i>
      </div>
      <div class="nav-card-content">
        <h3 class="title">תרומות טלפוניות</h3>
        <p class="description">מעקב וניהול תרומות והקלטות</p>
      </div>
    </a>

    <a *authGuardDirective="'ivrDonationDetails'" [routerLink]="['/donationCategories']"
      class="nav-card nav-card--categories">
      <div class="icon">
        <i class="fa fa-cogs"></i>
      </div>
      <div class="nav-card-content">
        <h3 class="title">הגדרות ושלוחות</h3>
        <p class="description">קביעת קטגוריות ופרמטרים</p>
      </div>
    </a>
    <div></div>
    <!-- Daily Stats Column - Fourth Column -->
    <div class="daily-stats-column">
      <!-- סימניית לוח שנה בצד -->
      <div class="daily-stats-bookmark">
        <span class="bookmark-title"><i class="fa fa-calendar"></i></span>
        <!-- <span class="bookmark-subtitle"><strong>סיכום יומי</strong></span> -->
        <span class="bookmark-date bookmark-date--left">
          {{model.yomiJewishDate}}
        </span>
      </div>

      <div class="daily-stats-grid">
        <div class="daily-stat-compact">
          <i class="fa fa-money stat-icon-compact"></i>
          <div class="stat-info-compact">
            <div class="stat-value-compact" *ngFor="let item of model.sumTrumotYomi">{{(item.value || 0) | number}} {{item.key}}</div>
            <div class="stat-label-compact">תרומות</div>
          </div>
        </div>

        <div class="daily-stat-compact">
          <i class="fa fa-sign-in stat-icon-compact"></i>
          <div class="stat-info-compact">
            <div class="stat-value-compact">{{model.countCnisotYomi || 0}}</div>
            <div class="stat-label-compact">כניסות</div>
          </div>
        </div>

        <div class="daily-stat-compact">
          <i class="fa fa-user-plus stat-icon-compact"></i>
          <div class="stat-info-compact">
            <div class="stat-value-compact">{{model.newDonors || 0}}</div>
            <div class="stat-label-compact">חדשים</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Activity Tracking Section -->
  <div class="dashboard-locator__activity fade-in-up" [formGroup]="centeralForm" *ngIf="centeralDataObj">
    <div class="dashboard-locator__activity-header">
      <h2>מעקב פעילות המערכת</h2>
      <div class="subtle-divider"></div>
    </div>

    <div class="dashboard-locator__activity-content">
      <!-- Left Section - Payments and Standing Orders (Wide) -->
      <div class="dashboard-locator__activity-section dashboard-locator__activity-section--payments">
        <div class="section-header">
          <h3>מערכת טלפונית</h3>
        </div>

        <div class="section-content">
          <div class="payment-stats" *ngIf="centeralDataObj?.mainReport">
            <div class="stat-item">
              <div class="value">0</div>
              <div class="label">סה"כ התחייבויות</div>
            </div>

            <div class="stat-item">
              <div class="value">0</div>
              <div class="label">תוכניות פעילות</div>
            </div>

            <div class="stat-item success">
              <div class="value">{{centeralDataObj.mainReport.sumSucceededAmount|number}}</div>
              <div class="label">סכום שנגבה</div>
              <div class="count">{{centeralDataObj.mainReport.countSucceededPayments || 0}} רשומות</div>
            </div>

            <div class="stat-item failed">
              <div class="value">{{centeralDataObj.mainReport.sumWaitingAmount|number}}</div>
              <div class="label">סכום לגביה</div>
              <div class="count">{{centeralDataObj.mainReport.countWaitingPayments || 0}} רשומות</div>
            </div>
          </div>

          <!-- Modern Filters -->
          <div class="filters">
            <div class="filter-row">
              <div class="filter-group">
                <button type="button" class="btn btn-outline-primary" (click)="setPriod(30)">30 יום</button>
                <button type="button" class="btn btn-outline-primary" (click)="setPriod(6)">7 ימים</button>
              </div>

              <date-input-range #releventDateRangeCom [placeHolderStart]="'מתאריך'" [withLabel]="false"
                [placeHolderEnd]="'עד לתאריך'" [dateRangeCtrl]="centeralForm.controls.relevantDateRange">Loading...
              </date-input-range>

              <mat-select class="form-control" placeholder="קטגוריה..." formControlName="donationCategoryID">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let c of servicesData.DonationCategories" [value]="c.id">
                  {{c.title}}
                </mat-option>
              </mat-select>

              <mat-select class="form-control narrow" placeholder="מטבע..." formControlName="currency">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let c of servicesData.Currencies" [value]="c.value">
                  {{c.name}}
                </mat-option>
              </mat-select>

              <div class="action-buttons">
                <button mat-mini-fab color="primary" title="סנן" (click)="loadCenteralData()">
                  <i class="fa fa-filter"></i>
                </button>
                <button mat-mini-fab color="primary" title="נקה סינונים" (click)="clerFilter()">
                  <i class="material-icons">clear</i>
                </button>
              </div>
            </div>
          </div>

          <!-- Charts Container -->
          <div class="charts-container">
            <div class="charts-col charts-col--summary">
              <div class="chart-wrapper">
                <div class="ibox-title tabs-container">
                  <ul class="nav nav-tabs">
                    <li><a class="nav-link active" data-toggle="tab" href="#tab-1"><i class="fa fa-pie-chart"></i></a>
                    </li>
                    <li><a class="nav-link" data-toggle="tab" href="#tab-2"><i class="fa fa-table"></i></a></li>
                  </ul>
                  <div class="tab-content">
                    <div id="tab-1" class="tab-pane active">
                      <div class="panel-body pie-chart-panel" *ngIf="pieChartDatasets">
                        <canvas baseChart [type]="'pie'" [datasets]="pieChartDatasets" [labels]="pieChartLabels"
                          [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                        </canvas>
                      </div>
                    </div>
                    <div id="tab-2" class="tab-pane">
                      <div class="panel-body">
                        <table class="table table-hover no-margins">
                          <thead>
                            <tr>
                              <th>קטגוריה</th>
                              <th>שיחות</th>
                              <th>ס"ה</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of centeralDataObj?.donationDetailsGroup">
                              <td><small>{{item.item1}}</small></td>
                              <td>{{item.item2}}</td>
                              <td>{{item.item3|number}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Phone System Metrics (moved here to fill the empty area) -->
              <div class="phone-system-metrics-grid">
                <div class="phone-system-metric-card success">
                  <h5 class="phone-system-metric-title">סכום כולל</h5>
                  <h1 class="phone-system-metric-value success">
                    <small class="phone-system-currency">{{ '' | orgCurrencySymbol }}</small>
                    {{centeralDataObj?.sumSucceededIvrDonationts|number}}
                  </h1>
                </div>

                <div class="phone-system-metric-card danger">
                  <h5 class="phone-system-metric-title">סכום שנכשל</h5>
                  <h1 class="phone-system-metric-value danger">
                    <small class="phone-system-currency">{{ '' | orgCurrencySymbol }}</small>
                    {{centeralDataObj?.sumFailedIvrDonations|number:'1.0-0'}}
                  </h1>
                </div>

                <div class="phone-system-metric-card success">
                  <h5 class="phone-system-metric-title">שיחות מוצלחות</h5>
                  <h1 class="phone-system-metric-value success">{{centeralDataObj?.countSucceededIvrDonationts}}</h1>
                </div>

                <div class="phone-system-metric-card danger">
                  <h5 class="phone-system-metric-title">שיחות שנכשלו</h5>
                  <h1 class="phone-system-metric-value danger">{{centeralDataObj?.countFailedIvrDonations}}</h1>
                </div>

                <div class="phone-system-metric-card">
                  <h5 class="phone-system-metric-title">ממוצע יומי</h5>
                  <h1 class="phone-system-metric-value">{{centeralDataObj?.averageDayCountSucceededIvrDonationts}}</h1>
                </div>

                <div class="phone-system-metric-card warning">
                  <h5 class="phone-system-metric-title">ממוצע לתרומה</h5>
                  <h1 class="phone-system-metric-value warning">
                    <small class="phone-system-currency">{{ '' | orgCurrencySymbol }}</small>
                    {{centeralDataObj?.averageUnitDonationSumSucceededIvrDonationts|number:'1.0-0'}}
                  </h1>
                </div>

                <div class="phone-system-metric-card">
                  <h5 class="phone-system-metric-title">תורמים חדשים</h5>
                  <h1 class="phone-system-metric-value">{{centeralDataObj?.newDonors}}</h1>
                </div>

                <div class="phone-system-metric-card phone-system-metric-card--placeholder" aria-hidden="true"></div>
              </div>
            </div>

            <div class="charts-col charts-col--bars" *ngIf="lineChartDatasets || amountsLineChartDatasets">
              <div class="chart-wrapper chart-wrapper--bars">
                <div class="bar-chart bar-chart--count" *ngIf="lineChartDatasets">
                  <div class="bar-chart__header">
                    <div class="bar-chart__title">
                      <i class="fa fa-phone bar-chart__icon" aria-hidden="true"></i>
                      <span>שיחות ליום</span>
                    </div>
                  </div>
                  <div class="bar-chart__canvas">
                    <canvas baseChart [type]="'bar'" [legend]="false" [datasets]="lineChartDatasets"
                      [labels]="lineChartLabels" [options]="lineChartOptions" [plugins]="lineChartPlugins">
                    </canvas>
                  </div>
                </div>

                <div class="bar-chart bar-chart--amounts" *ngIf="amountsLineChartDatasets">
                  <div class="bar-chart__header">
                    <div class="bar-chart__title">
                      <i class="fa fa-money bar-chart__icon" aria-hidden="true"></i>
                      <span>סכומים ליום</span>
                    </div>
                  </div>
                  <div class="bar-chart__canvas">
                    <canvas baseChart [type]="'bar'" [legend]="false" [datasets]="amountsLineChartDatasets"
                      [labels]="amountsLineChartLabels" [options]="amountsLineChartOptions" [plugins]="lineChartPlugins">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Section - Phone System (Narrow) -->
      <div class="dashboard-locator__activity-section dashboard-locator__activity-section--phone-system">
        <div class="section-header">
          <h3>הוראות קבע ותשלומים</h3>
        </div>

        <div class="section-content">
          <!-- Coming Soon Content -->
          <div class="coming-soon-placeholder">
            <div class="coming-soon-icon">
              <i class="fa fa-credit-card"></i>
            </div>
            <div class="coming-soon-text">
              <h4>בעז"ה כאן יופיע</h4>
              <p>מידע על פעילות בהוראות קבע ותשלומים</p>
            </div>
            <div class="coming-soon-features">
              <div class="feature-item">
                <i class="fa fa-check-circle"></i>
                <span>מעקב הוראות קבע</span>
              </div>
              <!-- <div class="feature-item">
                <i class="fa fa-check-circle"></i>
                <span>דוחות תשלומים מפורטים</span>
              </div> -->
              <div class="feature-item">
                <i class="fa fa-check-circle"></i>
                <span>נתוני גביה</span>
              </div>
              <div class="feature-item">
                <i class="fa fa-check-circle"></i>
                <span>עוד...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
